(function () {
  "use strict";

  window.addEventListener("load", function () {
    document.documentElement.classList.add("loaded");
  });
  document.addEventListener("DOMContentLoaded", init);

  function init() {
    setTimeout(function () {
      document.documentElement.classList.add("loaded");
    }, 100);

    stickyHeader();
    mobileMenu();
    faqAccordion();
    revealObserver();
    initROI();
    stickyBuyBar();
    productGallery();
    dashboardLive();
    cartDrawer();
    planQuiz();
    contactWidget();
    activeNavHighlight();
    buttonRipple();
    backToTop();
    testimonialsCarousel();
    faqSearch();
    scrollProgress();
    commandPalette();
    demoScenarios();
    parallaxOrbs();
    liveTimeline();
    countUpStats();
    savingsCalculator();
  }

  function stickyHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function mobileMenu() {
    var menu = document.querySelector("[data-mobile-menu]");
    var openBtn = document.querySelector("[data-menu-open]");
    var closeBtn = document.querySelector("[data-menu-close]");
    if (!menu) return;
    var open = function () { menu.classList.add("open"); document.body.style.overflow = "hidden"; };
    var close = function () { menu.classList.remove("open"); document.body.style.overflow = ""; };
    if (openBtn) openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });
  }

  function faqAccordion() {
    var items = document.querySelectorAll("[data-faq-item]");
    items.forEach(function (item) {
      var btn = item.querySelector(".faq-q");
      var ans = item.querySelector(".faq-a");
      if (!btn || !ans) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("open");
        items.forEach(function (o) {
          o.classList.remove("open");
          var a = o.querySelector(".faq-a");
          if (a) a.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add("open");
          ans.style.maxHeight = ans.scrollHeight + "px";
        }
      });
    });
    var first = document.querySelector("[data-faq-item]");
    if (first) {
      first.classList.add("open");
      var a = first.querySelector(".faq-a");
      if (a) a.style.maxHeight = a.scrollHeight + "px";
    }
  }

  function revealObserver() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("in");
          en.target.querySelectorAll("[data-bar]").forEach(function (b) {
            b.style.width = (b.getAttribute("data-bar") || 0) + "%";
          });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "-60px" });
    els.forEach(function (e) { io.observe(e); });
  }

  function stickyBuyBar() {
    var bar = document.querySelector("[data-sticky-buy]");
    var hero = document.querySelector(".product-hero-grid");
    if (!bar || !hero) return;
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var pastHero = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle("show", pastHero);
      });
    }, { threshold: 0 });
    io.observe(hero);
  }

  function productGallery() {
    var main = document.querySelector("[data-gallery-image]");
    var thumbs = document.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (!full || full === main.src) return;
        main.style.opacity = "0";
        setTimeout(function () {
          main.src = full;
          main.style.opacity = "1";
        }, 150);
        thumbs.forEach(function (o) { o.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  }

  function activeNavHighlight() {
    var navLinks = document.querySelectorAll('.nav-links a[href*="#"]');
    if (!navLinks.length || !("IntersectionObserver" in window)) return;
    var pairs = [];
    navLinks.forEach(function (link) {
      var hash = link.getAttribute("href").split("#")[1];
      if (!hash) return;
      var section = document.getElementById(hash);
      if (section) pairs.push({ link: link, section: section });
    });
    if (!pairs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var match = pairs.find(function (p) { return p.section === en.target; });
        if (!match) return;
        navLinks.forEach(function (l) { l.classList.remove("active"); });
        match.link.classList.add("active");
      });
    }, { rootMargin: "-45% 0px -45% 0px" });
    pairs.forEach(function (p) { io.observe(p.section); });
  }

  function buttonRipple() {
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".btn");
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height) * 1.4;
      var ripple = document.createElement("span");
      ripple.className = "btn-ripple";
      ripple.style.width = ripple.style.height = size + "px";
      ripple.style.left = (e.clientX - rect.left - size / 2) + "px";
      ripple.style.top = (e.clientY - rect.top - size / 2) + "px";
      btn.appendChild(ripple);
      ripple.addEventListener("animationend", function () { ripple.remove(); });
      setTimeout(function () { if (ripple.parentNode) ripple.remove(); }, 900);
    });
  }

  function backToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    var ring = document.querySelector("[data-progress-ring]");
    if (!btn) return;
    var circumference = 119.4;

    function onScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
      if (ring) ring.style.strokeDashoffset = String(circumference * (1 - progress));
      btn.classList.toggle("show", scrollTop > 500);
    }

    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function testimonialsCarousel() {
    var root = document.querySelector("[data-carousel]");
    if (!root) return;
    var track = root.querySelector("[data-carousel-track]");
    var slides = root.querySelectorAll("[data-carousel-slide]");
    var dots = root.querySelectorAll("[data-carousel-dot]");
    var prevBtn = root.querySelector("[data-carousel-prev]");
    var nextBtn = root.querySelector("[data-carousel-next]");
    if (!track || slides.length < 2) return;

    var index = 0;
    var autoplayTimer = null;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = "translateX(-" + (index * 100) + "%)";
      dots.forEach(function (d, di) { d.classList.toggle("active", di === index); });
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { next(); restartAutoplay(); });
    dots.forEach(function (d, di) {
      d.addEventListener("click", function () { goTo(di); restartAutoplay(); });
    });

    var startX = 0, dragDelta = 0, dragging = false;
    track.addEventListener("pointerdown", function (e) {
      dragging = true; startX = e.clientX; track.style.transition = "none";
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    });
    track.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      dragDelta = e.clientX - startX;
      track.style.transform = "translateX(calc(-" + (index * 100) + "% + " + dragDelta + "px))";
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = "";
      if (dragDelta < -60) next();
      else if (dragDelta > 60) prev();
      else goTo(index);
      dragDelta = 0;
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("pointerleave", function () { if (dragging) endDrag(); });

    function restartAutoplay() {
      if (reduceMotion) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(next, 6000);
    }

    goTo(0);
    restartAutoplay();
    root.addEventListener("mouseenter", function () { clearInterval(autoplayTimer); });
    root.addEventListener("mouseleave", restartAutoplay);
  }

  function faqSearch() {
    var input = document.querySelector("[data-faq-search]");
    if (!input) return;
    var items = document.querySelectorAll("[data-faq-item]");
    if (!items.length) return;
    var lastItem = items[items.length - 1];
    var container = lastItem.parentElement;
    var emptyState = document.createElement("p");
    emptyState.className = "faq-empty-state";
    emptyState.textContent = "No questions match your search.";
    if (container) container.appendChild(emptyState);

    input.addEventListener("input", function () {
      var q = input.value.trim().toLowerCase();
      var visibleCount = 0;
      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        var match = !q || text.indexOf(q) !== -1;
        item.style.display = match ? "" : "none";
        if (match) visibleCount++;
      });
      emptyState.classList.toggle("show", visibleCount === 0);
    });
  }

  function dashboardLive() {
    var root = document.querySelector("[data-dashboard]");
    if (!root) return;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var floatyContent = {
      a: [["Appointment booked", "Tue 2:30 PM \u00b7 J. Rivera"], ["Appointment booked", "Tomorrow 10:00 AM \u00b7 M. Chen"]],
      b: [["New qualified lead", "Enterprise \u00b7 $12k ARR"], ["New qualified lead", "Local business \u00b7 $3k ARR"]],
      c: [["CSAT 4.9/5", "Last 30 days"], ["5-star review", "\u201cAnswered instantly!\u201d"]]
    };
    if (!reduceMotion) {
      root.querySelectorAll("[data-floaty]").forEach(function (el, i) {
        var key = el.getAttribute("data-floaty");
        var pool = floatyContent[key];
        if (!pool) return;
        var idx = 0;
        setInterval(function () {
          idx = (idx + 1) % pool.length;
          el.style.transition = "opacity .4s";
          el.style.opacity = "0";
          setTimeout(function () {
            var ftEl = el.querySelector(".ft");
            var fsEl = el.querySelector(".fs");
            if (ftEl) ftEl.textContent = pool[idx][0];
            if (fsEl) fsEl.textContent = pool[idx][1];
            el.style.opacity = "1";
          }, 400);
        }, 5200 + i * 1100);
      });
    }

    var convoEl = root.querySelector("[data-convo]");
    if (convoEl) {
      var conversations = [
        [
          { who: "Caller", side: "caller", text: "Hi, do you have any openings tomorrow afternoon?" },
          { who: "AI", side: "ai", text: "Yes! I have 2:00 or 3:30 PM open. Which works better?" },
          { who: "Caller", side: "caller", text: "3:30 is perfect." },
          { who: "AI", side: "ai", text: "Booked for 3:30 PM \u2014 you'll get a text confirmation now." }
        ],
        [
          { who: "Caller", side: "caller", text: "What are your hours on Sunday?" },
          { who: "AI", side: "ai", text: "We're open 11 AM to 8 PM on Sundays. Want me to book you a spot?" },
          { who: "Caller", side: "caller", text: "Yes, table for two at six." },
          { who: "AI", side: "ai", text: "Done \u2014 table for 2, Sunday at 6 PM. See you then!" }
        ],
        [
          { who: "Caller", side: "caller", text: "This is urgent, I need to speak to someone right now." },
          { who: "AI", side: "ai", text: "Understood \u2014 connecting you with our team immediately." }
        ]
      ];

      if (reduceMotion) {
        convoEl.innerHTML = conversations[0].map(function (line) {
          return '<div class="convo-line ' + line.side + '"><span class="who">' + line.who + "</span>" + line.text + "</div>";
        }).join("");
      } else {
        runConvoLoop(convoEl, conversations, 0);
      }
    }

    function runConvoLoop(el, conversations, convoIndex) {
      el.innerHTML = "";
      var lines = conversations[convoIndex];
      typeLine(el, lines, 0, function () {
        setTimeout(function () {
          var next = (convoIndex + 1) % conversations.length;
          el.style.transition = "opacity .4s";
          el.style.opacity = "0";
          setTimeout(function () {
            el.style.opacity = "1";
            runConvoLoop(el, conversations, next);
          }, 450);
        }, 2600);
      });
    }

    function typeLine(el, lines, lineIndex, onDone) {
      if (lineIndex >= lines.length) { onDone(); return; }
      var line = lines[lineIndex];
      var wrap = document.createElement("div");
      wrap.className = "convo-line " + line.side;
      var whoEl = document.createElement("span");
      whoEl.className = "who";
      whoEl.textContent = line.who;
      wrap.appendChild(whoEl);
      var textNode = document.createTextNode("");
      wrap.appendChild(textNode);
      var cursor = document.createElement("span");
      cursor.className = "convo-cursor";
      wrap.appendChild(cursor);
      el.appendChild(wrap);

      var i = 0;
      var text = line.text;
      var timer = setInterval(function () {
        i++;
        textNode.textContent = text.slice(0, i);
        el.scrollTop = el.scrollHeight;
        if (i >= text.length) {
          clearInterval(timer);
          cursor.remove();
          setTimeout(function () { typeLine(el, lines, lineIndex + 1, onDone); }, 500);
        }
      }, 22);
    }

    var tabs = root.querySelectorAll("[data-activity-tab]");
    var panels = root.querySelectorAll("[data-activity-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var key = tab.getAttribute("data-activity-tab");
        tabs.forEach(function (t) { t.classList.toggle("active", t === tab); });
        panels.forEach(function (p) { p.hidden = p.getAttribute("data-activity-panel") !== key; });
      });
    });

    if (!reduceMotion) {
      var callsPool = [
        ["Inbound \u00b7 +1 (702) 41\u2026", "ok", "Booked"],
        ["Inbound \u00b7 +1 (206) 88\u2026", "info", "Qualified"],
        ["Inbound \u00b7 +1 (818) 22\u2026", "ok", "Booked"],
        ["Inbound \u00b7 +1 (503) 67\u2026", "warn", "Transferred"],
        ["Inbound \u00b7 +1 (773) 90\u2026", "ok", "Booked"],
        ["Inbound \u00b7 +1 (615) 34\u2026", "info", "Qualified"]
      ];
      var apptsPool = [
        ["A. Novak \u00b7 Consultation", "ok", "Confirmed"],
        ["R. Patel \u00b7 Follow-up", "ok", "Confirmed"],
        ["L. Kim \u00b7 New client intake", "info", "Pending"],
        ["D. Osei \u00b7 Table for 2", "ok", "Confirmed"]
      ];
      startLiveFeed(root.querySelector('[data-live-list="calls"]'), callsPool, 4200);
      startLiveFeed(root.querySelector('[data-live-list="appts"]'), apptsPool, 6800);
    }

    function startLiveFeed(container, pool, interval) {
      if (!container) return;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % pool.length;
        var item = pool[i];
        var row = document.createElement("div");
        row.className = "log-row";
        row.innerHTML = '<span class="nm">' + item[0] + '</span><span style="display:flex;gap:8px;align-items:center"><span class="tag ' + item[1] + '">' + item[2] + '</span><span class="log-time">just now</span></span>';
        container.insertBefore(row, container.firstChild);
        while (container.children.length > 5) {
          container.removeChild(container.lastChild);
        }
      }, interval);
    }
  }

  function cartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-cart-overlay]");
    var body = document.querySelector("[data-cart-drawer-body]");
    var countEls = document.querySelectorAll("[data-cart-count]");
    if (!drawer || !overlay || !body) return;

    function open() { overlay.classList.add("open"); drawer.classList.add("open"); document.body.style.overflow = "hidden"; }
    function close() { overlay.classList.remove("open"); drawer.classList.remove("open"); document.body.style.overflow = ""; }

    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); refreshCart(); });
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) close();
    });
    overlay.addEventListener("click", close);

    function money(cents) {
      return "$" + (Math.round(cents) / 100).toFixed(2);
    }

    function escapeHtml(str) {
      var div = document.createElement("div");
      div.textContent = String(str == null ? "" : str);
      return div.innerHTML;
    }

    function renderCart(cart) {
      if (!cart || !cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-drawer-empty">' +
          '<p class="lead">Your cart is empty.</p>' +
          '<a href="/#plans" class="btn btn-primary" data-cart-close style="margin-top:16px;display:inline-flex">View plans</a></div>';
        updateCount(0);
        return;
      }
      var rows = cart.items.map(function (item) {
        var title = (item.product_title || item.title || "").split("|")[0].trim();
        var img = item.image ? '<img src="' + item.image + '" alt="" width="72" height="72">' : "";
        var variant = (item.variant_title && item.variant_title !== "Default Title") ? '<div class="cart-line-variant">' + item.variant_title + "</div>" : "";
        var propsHtml = "";
        if (item.properties) {
          var propKeys = Object.keys(item.properties).filter(function (k) {
            return item.properties[k] && String(item.properties[k]).trim() !== "" && k.indexOf("_") !== 0;
          });
          if (propKeys.length) {
            propsHtml = '<div class="cart-line-props">' + propKeys.map(function (k) {
              return "<div><span>" + escapeHtml(k) + ":</span> " + escapeHtml(item.properties[k]) + "</div>";
            }).join("") + "</div>";
          }
        }
        return '<div class="cart-line">' +
          '<div class="cart-line-media">' + img + "</div>" +
          '<div class="cart-line-info">' +
            '<a href="' + item.url + '" class="cart-line-title">' + title + "</a>" +
            variant +
            propsHtml +
            '<button type="button" class="cart-line-remove" data-remove-key="' + item.key + '">Remove</button>' +
          "</div>" +
          '<div class="cart-line-price"><div>' + money(item.final_line_price) + '</div><div class="text-dim" style="font-size:.8rem;margin-top:4px">Qty ' + item.quantity + "</div></div>" +
        "</div>";
      }).join("");

      var hasAI = cart.items.some(function (i) { return i.product_type === "AI Service"; });
      var hasWebsite = cart.items.some(function (i) { return i.product_type === "Web Design"; });
      var crossSellHtml = "";
      if (hasAI && !hasWebsite) {
        crossSellHtml = '<div class="cart-cross-sell"><div class="t">Pair it with a custom website</div>' +
          '<div class="d">Most clients bundle their AI receptionist with a conversion-ready site.</div>' +
          '<a href="/products/custom-built-website">View website design ' +
          '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg></a></div>';
      } else if (hasWebsite && !hasAI) {
        crossSellHtml = '<div class="cart-cross-sell"><div class="t">Add an AI receptionist</div>' +
          '<div class="d">Never miss a call from the traffic your new site brings in.</div>' +
          '<a href="/#plans">View plans ' +
          '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg></a></div>';
      }

      body.innerHTML = '<div class="cart-lines">' + rows + "</div>" +
        '<div class="cart-summary glass-panel">' +
          '<div class="cart-summary-row"><span class="text-dim">Subtotal</span><span class="h3">' + money(cart.total_price) + "</span></div>" +
          '<p class="text-dim" style="font-size:.8rem;margin-top:8px">Taxes and any recurring billing terms are calculated at checkout.</p>' +
          '<a href="/checkout" class="btn btn-primary" style="width:100%;margin-top:20px;justify-content:center">Checkout</a>' +
        "</div>" + crossSellHtml;

      body.querySelectorAll("[data-remove-key]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var key = btn.getAttribute("data-remove-key");
          btn.disabled = true;
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { window.location.href = "/cart"; });
        });
      });

      updateCount(cart.item_count);
    }

    function updateCount(n) {
      countEls.forEach(function (el) {
        el.textContent = n;
        el.classList.toggle("show", n > 0);
      });
    }

    function refreshCart() {
      fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    }

    document.querySelectorAll(".ajax-cart-form").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("button[type=submit]");
        var originalHtml = btn ? btn.innerHTML : "";
        if (btn) { btn.disabled = true; btn.style.opacity = ".7"; }
        fetch("/cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" }
        })
          .then(function (r) {
            if (!r.ok) { return r.json().then(function (d) { throw new Error(d.description || "add failed"); }); }
            return r.json();
          })
          .then(function () { return fetch("/cart.js"); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            renderCart(cart);
            open();
            if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; }
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; }
            form.submit();
          });
      });
    });

    refreshCart();
  }

  function planQuiz() {
    var overlay = document.querySelector("[data-quiz-overlay]");
    if (!overlay) return;
    var steps = overlay.querySelectorAll("[data-quiz-step]");
    var progressEls = overlay.querySelectorAll("[data-quiz-progress] span");
    var current = 0;
    var answers = {};

    var PLANS = {
      signal: { name: "Signal", price: "$350/mo", url: "/products/ai-receptionist-small-business", desc: "Perfect for solo operators and small local businesses just getting started with AI." },
      prime: { name: "Prime", price: "$450/mo", url: "/products/ai-receptionist-medium-business", desc: "Built for growing teams that need lead qualification and a website that converts." },
      elevate: { name: "Elevate", price: "$600/mo", url: "/products/ai-receptionist-large-business", desc: "Engineered for high-volume operations handling thousands of calls a month." }
    };

    function show(index) {
      current = index;
      steps.forEach(function (s, i) { s.classList.toggle("active", i === index); });
      progressEls.forEach(function (p, i) {
        p.classList.toggle("done", i < index);
        p.classList.toggle("active", i === index);
      });
    }

    function open() { overlay.classList.add("open"); document.body.style.overflow = "hidden"; answers = {}; show(0); }
    function close() { overlay.classList.remove("open"); document.body.style.overflow = ""; }

    document.querySelectorAll("[data-quiz-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    overlay.querySelectorAll("[data-quiz-close]").forEach(function (b) { b.addEventListener("click", close); });
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });

    overlay.querySelectorAll("[data-quiz-answer]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var stepEl = btn.closest("[data-quiz-step]");
        var q = stepEl ? stepEl.getAttribute("data-quiz-step") : "";
        answers[q] = btn.getAttribute("data-quiz-answer");
        var next = current + 1;
        if (next < steps.length - 1) {
          show(next);
        } else {
          renderResult();
          show(steps.length - 1);
        }
      });
    });

    overlay.querySelectorAll("[data-quiz-back]").forEach(function (btn) {
      btn.addEventListener("click", function () { if (current > 0) show(current - 1); });
    });

    function renderResult() {
      var size = answers.size || "small";
      var volume = answers.volume || "low";
      var key = "signal";
      if (size === "large" || volume === "high") key = "elevate";
      else if (size === "medium" || volume === "medium") key = "prime";
      var plan = PLANS[key];
      var resultEl = overlay.querySelector("[data-quiz-result]");
      if (resultEl) {
        resultEl.innerHTML =
          '<div class="quiz-result">' +
            '<span class="plan-badge" style="margin:0 auto 16px;display:inline-block">Recommended for you</span>' +
            '<h3 class="h3" style="font-size:1.6rem">' + plan.name + "</h3>" +
            '<p class="lead" style="margin-top:10px">' + plan.desc + "</p>" +
            '<div class="plan-price" style="justify-content:center;margin:20px 0"><span class="amount text-gradient" style="font-size:2.25rem">' + plan.price + "</span></div>" +
            '<a href="' + plan.url + '" class="btn btn-primary" style="width:100%;justify-content:center">See the ' + plan.name + " plan " +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg></a>' +
          "</div>";
      }
    }
  }

  function contactWidget() {
    var overlay = document.querySelector("[data-contact-overlay]");
    var fab = document.querySelector("[data-contact-open]");
    if (!overlay || !fab) return;

    function open() { overlay.classList.add("open"); document.body.style.overflow = "hidden"; }
    function close() { overlay.classList.remove("open"); document.body.style.overflow = ""; }

    fab.addEventListener("click", open);
    overlay.querySelectorAll("[data-contact-close]").forEach(function (b) { b.addEventListener("click", close); });
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });

    if (overlay.getAttribute("data-auto-open") === "true") {
      open();
    }
  }

  /* ---------- ROI calculator ---------- */
  /* captureMultiplier reflects real differences between tiers: higher tiers add
     capacity headroom and (Elevate) automatic callback follow-ups, so they
     recover a larger share of otherwise-missed calls. Modest, not dramatic. */
  var PLAN_TIERS = [
    { cost: 350, name: "Signal", captureMultiplier: 1.0 },
    { cost: 450, name: "Prime", captureMultiplier: 1.12 },
    { cost: 600, name: "Elevate", captureMultiplier: 1.28 }
  ];

  /* Conservative average handling time for a small-business inbound call,
     used only to estimate phone hours handed back to the team. */
  var AVG_CALL_MINUTES = 3;

  /* Typical starting points per industry — the visitor can adjust every one.
     Deliberately conservative: overstated defaults make the whole calculator
     read as a scam, which costs more credibility than the bigger number buys. */
  var INDUSTRY_PRESETS = {
    general: { calls: 200, missed: 25, conv: 20, value: 400 },
    restaurant: { calls: 600, missed: 25, conv: 30, value: 65 },
    hvac: { calls: 150, missed: 25, conv: 30, value: 400 },
    salon: { calls: 300, missed: 25, conv: 30, value: 90 },
    dental: { calls: 200, missed: 20, conv: 25, value: 450 },
    auto: { calls: 200, missed: 25, conv: 30, value: 300 },
    professional: { calls: 120, missed: 20, conv: 20, value: 900 }
  };

  function fmtK(n) {
    return n >= 1000 ? "$" + (n / 1000).toFixed(n >= 10000 ? 0 : 1) + "k" : "$" + Math.round(n);
  }
  function fmtFull(n) { return "$" + Math.round(n).toLocaleString("en-US"); }
  function fmtPayback(days) {
    if (!isFinite(days) || days <= 0) return "\u2014";
    if (days < 1) return "the same day";
    if (days === 1) return "1 day";
    if (days > 365) return "just over a year";
    return Math.ceil(days) + " days";
  }

  function initROI() {
    var root = document.querySelector("[data-roi]");
    if (!root) return;

    var industrySelect = root.querySelector("[data-roi-industry]");

    var inputs = {
      calls: root.querySelector("[data-roi-calls]"),
      missed: root.querySelector("[data-roi-missed]"),
      conv: root.querySelector("[data-roi-conv]"),
      value: root.querySelector("[data-roi-value]"),
      plan: root.querySelector("[data-roi-plan]")
    };
    var out = {
      calls: root.querySelector("[data-out-calls]"),
      missed: root.querySelector("[data-out-missed]"),
      conv: root.querySelector("[data-out-conv]"),
      value: root.querySelector("[data-out-value]"),
      plan: root.querySelector("[data-out-plan]"),
      lost: root.querySelector("[data-out-lost]")
    };
    var stats = {
      recovered: root.querySelector("[data-stat-recovered]"),
      customers: root.querySelector("[data-stat-new]"),
      roi: root.querySelector("[data-stat-return]"),
      net: root.querySelector("[data-stat-net]"),
      hours: root.querySelector("[data-stat-hours]")
    };
    var lossEls = {
      annual: root.querySelector("[data-roi-annual-loss]"),
      monthly: root.querySelector("[data-roi-monthly-loss]"),
      missedCount: root.querySelector("[data-roi-missed-count]")
    };
    var paybackEl = root.querySelector("[data-roi-payback]");
    var svg = root.querySelector("[data-roi-chart]");
    var prev = { recovered: 0, customers: 0, roi: 0, net: 0, hours: 0, annualLoss: 0, monthlyLoss: 0, missedCount: 0 };
    var prevPts = null;
    var chartAnimFrame = null;

    function setFill(el) {
      var min = +el.min, max = +el.max, val = +el.value;
      var pct = ((val - min) / (max - min)) * 100;
      el.style.setProperty("--fill", pct + "%");
      el.classList.add("filled");
    }

    function animateNumber(el, from, to, fmt) {
      if (!el) return;
      var start = null, dur = 600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(from + (to - from) * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function computePoints(monthly, planCost) {
      var W = 500, H = 220, padL = 8, padR = 8, padT = 8, padB = 8;
      var n = 12;
      var maxV = Math.max(monthly * n, planCost * n, 1);
      var xw = (W - padL - padR) / (n - 1);
      var yScale = (H - padT - padB) / maxV;
      var rec = [], cost = [];
      for (var i = 0; i < n; i++) {
        var x = padL + i * xw;
        rec.push([x, H - padB - monthly * (i + 1) * yScale]);
        cost.push([x, H - padB - planCost * (i + 1) * yScale]);
      }
      return { rec: rec, cost: cost };
    }

    function pathFromPoints(pts) {
      return pts.map(function (p, i) { return (i ? "L" : "M") + p[0].toFixed(1) + " " + p[1].toFixed(1); }).join(" ");
    }

    function renderChartFrame(recPts, costPts) {
      if (!svg) return;
      var H = 220, padB = 8, padL = 8;
      var line = pathFromPoints(recPts);
      var area = line + " L" + recPts[recPts.length - 1][0].toFixed(1) + " " + (H - padB) + " L" + padL + " " + (H - padB) + " Z";
      var costLine = pathFromPoints(costPts);
      var dots = recPts.map(function (p, i) {
        var isLast = i === recPts.length - 1;
        var r = isLast ? 5.5 : 3;
        var glow = isLast ? ' filter="drop-shadow(0 0 6px rgba(77,141,255,.9))"' : "";
        return '<circle cx="' + p[0].toFixed(1) + '" cy="' + p[1].toFixed(1) + '" r="' + r + '" fill="#4d8dff" stroke="#0b1120" stroke-width="1.5"' + glow + "/>";
      }).join("");
      svg.innerHTML =
        '<defs><linearGradient id="roiFill" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0%" stop-color="#4d8dff" stop-opacity="0.55"/>' +
        '<stop offset="100%" stop-color="#4d8dff" stop-opacity="0"/></linearGradient></defs>' +
        '<path d="' + area + '" fill="url(#roiFill)"/>' +
        '<path d="' + costLine + '" fill="none" stroke="rgba(255,255,255,0.35)" stroke-width="1.4" stroke-dasharray="4 4"/>' +
        '<path d="' + line + '" fill="none" stroke="#4d8dff" stroke-width="2.6"/>' +
        dots;
    }

    function animateChart(newPts) {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (chartAnimFrame) cancelAnimationFrame(chartAnimFrame);
      if (!prevPts || reduceMotion) {
        renderChartFrame(newPts.rec, newPts.cost);
        prevPts = newPts;
        return;
      }
      var fromRec = prevPts.rec, fromCost = prevPts.cost;
      var start = null, dur = 500;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var curRec = newPts.rec.map(function (pt, i) {
          var fy = fromRec[i] ? fromRec[i][1] : pt[1];
          return [pt[0], fy + (pt[1] - fy) * eased];
        });
        var curCost = newPts.cost.map(function (pt, i) {
          var fy = fromCost[i] ? fromCost[i][1] : pt[1];
          return [pt[0], fy + (pt[1] - fy) * eased];
        });
        renderChartFrame(curRec, curCost);
        if (p < 1) {
          chartAnimFrame = requestAnimationFrame(step);
        } else {
          prevPts = newPts;
        }
      }
      chartAnimFrame = requestAnimationFrame(step);
    }

    function drawChart(monthly, planCost) {
      if (!svg) return;
      animateChart(computePoints(monthly, planCost));
    }

    function recalc() {
      var calls = +inputs.calls.value;
      var missedRate = +inputs.missed.value;
      var conv = +inputs.conv.value;
      var avg = +inputs.value.value;
      var planIdx = +inputs.plan.value;
      var tier = PLAN_TIERS[planIdx];
      var planCost = tier.cost;

      var missedCalls = (calls * missedRate) / 100;
      var effectiveConv = Math.min(conv * tier.captureMultiplier, 100);
      var custs = (missedCalls * effectiveConv) / 100;
      var revenue = custs * avg;
      var roi = planCost > 0 ? revenue / planCost : 0;
      var net = revenue * 12 - planCost * 12;
      var paybackDays = revenue > 0 ? planCost / (revenue / 30) : Infinity;

      /* What the missed calls cost TODAY, using the visitor's own conversion rate
         (not the AI-assisted rate) — this is the honest "before" figure. */
      var monthlyLoss = (missedCalls * conv / 100) * avg;
      var annualLoss = monthlyLoss * 12;

      /* Phone time handed back to the team. AVG_CALL_MINUTES is a conservative
         industry-typical handling time, including the short calls. */
      var hoursSaved = (calls * AVG_CALL_MINUTES) / 60;

      if (out.calls) out.calls.textContent = calls.toLocaleString();
      if (out.missed) out.missed.textContent = missedRate + "%";
      if (out.conv) out.conv.textContent = conv + "%";
      if (out.value) out.value.textContent = fmtK(avg);
      if (out.plan) out.plan.textContent = tier.name + " \u00b7 $" + planCost.toLocaleString() + "/mo";
      if (out.lost) out.lost.textContent = Math.round(missedCalls) + " calls/mo \u00b7 " + fmtFull(revenue) + " lost";
      if (paybackEl) paybackEl.textContent = fmtPayback(paybackDays);

      Object.keys(inputs).forEach(function (k) { setFill(inputs[k]); });

      animateNumber(stats.recovered, prev.recovered, revenue, fmtFull);
      animateNumber(stats.customers, prev.customers, custs, function (v) { return Math.round(v).toString(); });
      animateNumber(stats.roi, prev.roi, roi, function (v) { return v.toFixed(1) + "\u00d7"; });
      animateNumber(stats.net, prev.net, net, fmtFull);
      animateNumber(stats.hours, prev.hours, hoursSaved, function (v) { return Math.round(v) + "h"; });
      animateNumber(lossEls.annual, prev.annualLoss, annualLoss, fmtFull);
      animateNumber(lossEls.monthly, prev.monthlyLoss, monthlyLoss, fmtFull);
      animateNumber(lossEls.missedCount, prev.missedCount, missedCalls, function (v) { return Math.round(v).toLocaleString("en-US"); });
      prev = {
        recovered: revenue, customers: custs, roi: roi, net: net, hours: hoursSaved,
        annualLoss: annualLoss, monthlyLoss: monthlyLoss, missedCount: missedCalls
      };

      drawChart(revenue, planCost);
    }

    Object.keys(inputs).forEach(function (k) {
      if (inputs[k]) inputs[k].addEventListener("input", recalc);
    });

    if (industrySelect) {
      industrySelect.addEventListener("change", function () {
        var preset = INDUSTRY_PRESETS[industrySelect.value];
        if (!preset) return;
        if (inputs.calls) inputs.calls.value = preset.calls;
        if (inputs.missed) inputs.missed.value = preset.missed;
        if (inputs.conv) inputs.conv.value = preset.conv;
        if (inputs.value) inputs.value.value = preset.value;
        recalc();
      });
    }

    recalc();
  }

  /* ---------- Scroll progress bar ---------- */
  function scrollProgress() {
    var fill = document.querySelector("[data-scroll-progress]");
    if (!fill) return;
    function onScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
      fill.style.width = (progress * 100) + "%";
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Command palette (Cmd/Ctrl+K quick actions) ---------- */
  function commandPalette() {
    var overlay = document.querySelector("[data-cmdk-overlay]");
    if (!overlay) return;
    var input = overlay.querySelector("[data-cmdk-input]");
    var list = overlay.querySelector("[data-cmdk-list]");
    var items = Array.prototype.slice.call(overlay.querySelectorAll(".cmdk-item"));
    var triggers = document.querySelectorAll("[data-cmdk-open]");

    function open() {
      overlay.classList.add("open");
      document.body.style.overflow = "hidden";
      input.value = "";
      filter("");
      setTimeout(function () { input.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove("open");
      document.body.style.overflow = "";
    }

    triggers.forEach(function (t) { t.addEventListener("click", open); });
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });

    document.addEventListener("keydown", function (e) {
      var isMac = navigator.platform ? /Mac/.test(navigator.platform) : /Mac/.test(navigator.userAgent);
      var mod = isMac ? e.metaKey : e.ctrlKey;
      if (mod && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        if (overlay.classList.contains("open")) close(); else open();
      } else if (e.key === "Escape" && overlay.classList.contains("open")) {
        close();
      }
    });

    function filter(q) {
      q = q.toLowerCase();
      var anyVisible = false;
      items.forEach(function (item) {
        var match = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
        item.style.display = match ? "" : "none";
        if (match) anyVisible = true;
      });
      var empty = list.querySelector(".cmdk-empty");
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement("div");
          empty.className = "cmdk-empty";
          empty.textContent = "No matching actions.";
          list.appendChild(empty);
        }
      } else if (empty) {
        empty.remove();
      }
    }

    input.addEventListener("input", function () { filter(input.value); });

    items.forEach(function (item) {
      item.addEventListener("click", function () {
        var scrollTarget = item.getAttribute("data-cmdk-scroll");
        var navTarget = item.getAttribute("data-cmdk-nav");
        if (scrollTarget) {
          close();
          var el = document.querySelector(scrollTarget);
          if (el) setTimeout(function () { el.scrollIntoView({ behavior: "smooth" }); }, 150);
        } else if (navTarget) {
          window.location.href = navTarget;
        } else if (item.hasAttribute("data-cmdk-cart")) {
          close();
          var cartBtn = document.querySelector("[data-cart-open]");
          if (cartBtn) setTimeout(function () { cartBtn.click(); }, 150);
        } else if (item.hasAttribute("data-cmdk-quiz")) {
          close();
          var quizBtn = document.querySelector("[data-quiz-open]");
          if (quizBtn) setTimeout(function () { quizBtn.click(); }, 150);
        } else if (item.hasAttribute("data-cmdk-contact")) {
          close();
          var contactBtn = document.querySelector("[data-contact-open]");
          if (contactBtn) setTimeout(function () { contactBtn.click(); }, 150);
        }
      });
    });
  }

  /* ---------- Interactive scenario demo tabs ---------- */
  function demoScenarios() {
    var tabs = document.querySelectorAll("[data-demo-tab]");
    var panels = document.querySelectorAll("[data-demo-panel]");
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var key = tab.getAttribute("data-demo-tab");
        tabs.forEach(function (t) { t.classList.toggle("active", t === tab); });
        panels.forEach(function (p) { p.classList.toggle("active", p.getAttribute("data-demo-panel") === key); });
      });
    });
  }

  /* ---------- Parallax depth on background orbs ---------- */
  function parallaxOrbs() {
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;
    var wraps = document.querySelectorAll("[data-parallax]");
    if (!wraps.length) return;
    function onScroll() {
      var scrollY = window.scrollY || document.documentElement.scrollTop;
      wraps.forEach(function (w) {
        var speed = parseFloat(w.getAttribute("data-parallax")) || 0;
        w.style.transform = "translateY(" + (scrollY * speed).toFixed(1) + "px)";
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Live process timeline (homepage) ---------- */
  function liveTimeline() {
    var items = document.querySelectorAll("[data-timeline-item]");
    if (!items.length) return;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;
    var idx = 0;
    setInterval(function () {
      items.forEach(function (it) { it.classList.remove("active"); });
      idx = (idx + 1) % items.length;
      items[idx].classList.add("active");
    }, 2600);
  }

  /* ---------- Scroll-triggered count-up numbers ---------- */
  function countUpStats() {
    var els = document.querySelectorAll("[data-count-up]");
    if (!els.length) return;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function formatCount(value, el) {
      var prefix = el.getAttribute("data-count-prefix") || "";
      var suffix = el.getAttribute("data-count-suffix") || "";
      var format = el.getAttribute("data-count-format");
      var display;
      if (format === "k") {
        display = Math.round(value / 1000) + "k";
      } else {
        display = Math.round(value).toLocaleString("en-US");
      }
      return prefix + display + suffix;
    }

    function animateEl(el) {
      var target = parseFloat(el.getAttribute("data-count-to")) || 0;
      if (reduceMotion) {
        el.textContent = formatCount(target, el);
        return;
      }
      var start = null;
      var dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = formatCount(target * eased, el);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = formatCount(target, el);
      }
      requestAnimationFrame(step);
    }

    if (!("IntersectionObserver" in window)) {
      els.forEach(animateEl);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          animateEl(en.target);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Savings calculator (human receptionist vs AutoElevate) ---------- */
  function savingsCalculator() {
    var root = document.querySelector("[data-savings-calc]");
    if (!root) return;

    var PLANS = [
      { name: "Signal", cost: 350 },
      { name: "Prime", cost: 450 },
      { name: "Elevate", cost: 600 }
    ];
    var OVERHEAD_MULTIPLIER = 1.25;
    var WEEKS_PER_MONTH = 4.33;

    var wageInput = root.querySelector("[data-sc-wage]");
    var hoursInput = root.querySelector("[data-sc-hours]");
    var planInput = root.querySelector("[data-sc-plan]");
    var outWage = root.querySelector("[data-sc-out-wage]");
    var outHours = root.querySelector("[data-sc-out-hours]");
    var outPlan = root.querySelector("[data-sc-out-plan]");
    var outHuman = root.querySelector("[data-sc-human]");
    var outAi = root.querySelector("[data-sc-ai]");
    var outSavingsMonthly = root.querySelector("[data-sc-savings-monthly]");
    var outSavingsYearly = root.querySelector("[data-sc-savings-yearly]");
    var outSavingsPct = root.querySelector("[data-sc-savings-pct]");

    function fmtMoney(n) {
      return "$" + Math.round(n).toLocaleString("en-US");
    }

    function setFill(el) {
      if (!el) return;
      var min = +el.min, max = +el.max, val = +el.value;
      var pct = ((val - min) / (max - min)) * 100;
      el.style.setProperty("--fill", pct + "%");
      el.classList.add("filled");
    }

    function recalc() {
      var wage = +wageInput.value;
      var hours = +hoursInput.value;
      var planIdx = +planInput.value;
      var plan = PLANS[planIdx];

      var humanMonthly = wage * hours * WEEKS_PER_MONTH * OVERHEAD_MULTIPLIER;
      var aiMonthly = plan.cost;
      var savingsMonthly = Math.max(humanMonthly - aiMonthly, 0);
      var savingsYearly = savingsMonthly * 12;
      var savingsPct = humanMonthly > 0 ? Math.round((savingsMonthly / humanMonthly) * 100) : 0;

      if (outWage) outWage.textContent = "$" + wage.toFixed(2).replace(/\.00$/, "");
      if (outHours) outHours.textContent = hours;
      if (outPlan) outPlan.textContent = plan.name + " \u00b7 $" + plan.cost + "/mo";
      if (outHuman) outHuman.textContent = fmtMoney(humanMonthly) + "/mo";
      if (outAi) outAi.textContent = fmtMoney(aiMonthly) + "/mo";
      if (outSavingsMonthly) outSavingsMonthly.textContent = fmtMoney(savingsMonthly) + "/mo";
      if (outSavingsYearly) outSavingsYearly.textContent = fmtMoney(savingsYearly);
      if (outSavingsPct) outSavingsPct.textContent = savingsPct + "% less";

      setFill(wageInput);
      setFill(hoursInput);
      setFill(planInput);
    }

    [wageInput, hoursInput, planInput].forEach(function (el) {
      if (el) el.addEventListener("input", recalc);
    });

    recalc();
  }
})();
